// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== IRIS Mascot Component ===== */

.iris-mascot {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
}

.iris-mascot__figure {
    position: relative;
    animation: irisBreathe 4s ease-in-out infinite;
}

.iris-mascot__svg {
    width: 100%;
    height: 100%;
    overflow: visible;
}

/* Colorful iris - matches app accent gradient */
.iris-mascot__iris {
    fill: var(--accent-gradient-start, #667eea);
}

/* Gentle breathing animation */
@keyframes irisBreathe {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-3px); }
}

/* Periodic blinking */
.iris-mascot__eyes {
    animation: irisBlink 4s ease-in-out infinite;
    transform-box: fill-box;
    transform-origin: center;
}

@keyframes irisBlink {
    0%, 42%, 48%, 100% { transform: scaleY(1); }
    45% { transform: scaleY(0.08); }
}

/* Sleepy eyes don't blink */
.iris-mascot__eyes--sleepy {
    animation: none;
}

/* Sleepy Z's float */
.iris-mascot__zzz text {
    animation: irisZzz 2.5s ease-in-out infinite;
}

.iris-mascot__zzz text:nth-child(2) {
    animation-delay: 0.3s;
}

.iris-mascot__zzz text:nth-child(3) {
    animation-delay: 0.6s;
}

@keyframes irisZzz {
    0%, 100% { opacity: 0.3; transform: translateY(0); }
    50% { opacity: 1; transform: translateY(-6px); }
}

/* Excited bounce */
.iris-mascot--excited .iris-mascot__figure {
    animation: irisExcitedBounce 1.5s ease-in-out infinite;
}

@keyframes irisExcitedBounce {
    0%, 100% { transform: translateY(0) rotate(0deg); }
    25% { transform: translateY(-6px) rotate(-2deg); }
    75% { transform: translateY(-6px) rotate(2deg); }
}

/* Speech bubble */
.iris-mascot__bubble {
    background: var(--bg-card);
    border: 2px solid var(--border-secondary);
    border-radius: 16px;
    padding: 10px 16px;
    max-width: 280px;
    text-align: center;
    position: relative;
    animation: irisBubbleIn 0.4s ease-out;
}

.iris-mascot__bubble::before {
    content: '';
    position: absolute;
    top: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid var(--border-secondary);
}

.iris-mascot__bubble::after {
    content: '';
    position: absolute;
    top: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid var(--bg-card);
}

.iris-mascot__bubble span {
    font-size: 14px;
    color: var(--text-secondary);
    line-height: 1.4;
}

@keyframes irisBubbleIn {
    from { opacity: 0; transform: translateY(4px); }
    to { opacity: 1; transform: translateY(0); }
}

/* ===== Size variants ===== */
.iris-mascot--small .iris-mascot__bubble {
    max-width: 220px;
    padding: 8px 12px;
}

.iris-mascot--small .iris-mascot__bubble span {
    font-size: 13px;
}

.iris-mascot--large .iris-mascot__bubble {
    max-width: 340px;
    padding: 12px 20px;
}

.iris-mascot--large .iris-mascot__bubble span {
    font-size: 16px;
}

/* ===== Integration: Landing page ===== */
.iris-greeting {
    display: flex;
    justify-content: center;
    padding: 24px 24px 0;
}

/* ===== Integration: Dashboard ===== */
.iris-dashboard {
    display: flex;
    justify-content: center;
    margin: 16px 0 8px;
}

/* ===== Integration: Exercise finish ===== */
.iris-finish {
    display: flex;
    justify-content: center;
    animation: celebrationIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
    .iris-greeting {
        padding: 16px 16px 0;
    }

    .iris-mascot__bubble {
        max-width: 240px;
    }
}

@media (max-width: 480px) {
    .iris-mascot__bubble {
        max-width: 200px;
        padding: 8px 12px;
    }

    .iris-mascot__bubble span {
        font-size: 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/IrisMascot.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA,gDAAgD;AAChD;IACI,2CAA2C;AAC/C;;AAEA,+BAA+B;AAC/B;IACI,WAAW,wBAAwB,EAAE;IACrC,MAAM,2BAA2B,EAAE;AACvC;;AAEA,sBAAsB;AACtB;IACI,4CAA4C;IAC5C,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB,oBAAoB,EAAE;IAC3C,MAAM,uBAAuB,EAAE;AACnC;;AAEA,4BAA4B;AAC5B;IACI,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW,YAAY,EAAE,wBAAwB,EAAE;IACnD,MAAM,UAAU,EAAE,2BAA2B,EAAE;AACnD;;AAEA,mBAAmB;AACnB;IACI,sDAAsD;AAC1D;;AAEA;IACI,WAAW,qCAAqC,EAAE;IAClD,MAAM,yCAAyC,EAAE;IACjD,MAAM,wCAAwC,EAAE;AACpD;;AAEA,kBAAkB;AAClB;IACI,0BAA0B;IAC1B,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,8BAA8B;AAC9B;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA,6CAA6C;AAC7C;IACI,aAAa;IACb,uBAAuB;IACvB,+DAA+D;AACnE;;AAEA,2BAA2B;AAC3B;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* ===== IRIS Mascot Component ===== */\n\n.iris-mascot {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n}\n\n.iris-mascot__figure {\n    position: relative;\n    animation: irisBreathe 4s ease-in-out infinite;\n}\n\n.iris-mascot__svg {\n    width: 100%;\n    height: 100%;\n    overflow: visible;\n}\n\n/* Colorful iris - matches app accent gradient */\n.iris-mascot__iris {\n    fill: var(--accent-gradient-start, #667eea);\n}\n\n/* Gentle breathing animation */\n@keyframes irisBreathe {\n    0%, 100% { transform: translateY(0); }\n    50% { transform: translateY(-3px); }\n}\n\n/* Periodic blinking */\n.iris-mascot__eyes {\n    animation: irisBlink 4s ease-in-out infinite;\n    transform-box: fill-box;\n    transform-origin: center;\n}\n\n@keyframes irisBlink {\n    0%, 42%, 48%, 100% { transform: scaleY(1); }\n    45% { transform: scaleY(0.08); }\n}\n\n/* Sleepy eyes don't blink */\n.iris-mascot__eyes--sleepy {\n    animation: none;\n}\n\n/* Sleepy Z's float */\n.iris-mascot__zzz text {\n    animation: irisZzz 2.5s ease-in-out infinite;\n}\n\n.iris-mascot__zzz text:nth-child(2) {\n    animation-delay: 0.3s;\n}\n\n.iris-mascot__zzz text:nth-child(3) {\n    animation-delay: 0.6s;\n}\n\n@keyframes irisZzz {\n    0%, 100% { opacity: 0.3; transform: translateY(0); }\n    50% { opacity: 1; transform: translateY(-6px); }\n}\n\n/* Excited bounce */\n.iris-mascot--excited .iris-mascot__figure {\n    animation: irisExcitedBounce 1.5s ease-in-out infinite;\n}\n\n@keyframes irisExcitedBounce {\n    0%, 100% { transform: translateY(0) rotate(0deg); }\n    25% { transform: translateY(-6px) rotate(-2deg); }\n    75% { transform: translateY(-6px) rotate(2deg); }\n}\n\n/* Speech bubble */\n.iris-mascot__bubble {\n    background: var(--bg-card);\n    border: 2px solid var(--border-secondary);\n    border-radius: 16px;\n    padding: 10px 16px;\n    max-width: 280px;\n    text-align: center;\n    position: relative;\n    animation: irisBubbleIn 0.4s ease-out;\n}\n\n.iris-mascot__bubble::before {\n    content: '';\n    position: absolute;\n    top: -8px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 0;\n    height: 0;\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    border-bottom: 8px solid var(--border-secondary);\n}\n\n.iris-mascot__bubble::after {\n    content: '';\n    position: absolute;\n    top: -5px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 0;\n    height: 0;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid var(--bg-card);\n}\n\n.iris-mascot__bubble span {\n    font-size: 14px;\n    color: var(--text-secondary);\n    line-height: 1.4;\n}\n\n@keyframes irisBubbleIn {\n    from { opacity: 0; transform: translateY(4px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n/* ===== Size variants ===== */\n.iris-mascot--small .iris-mascot__bubble {\n    max-width: 220px;\n    padding: 8px 12px;\n}\n\n.iris-mascot--small .iris-mascot__bubble span {\n    font-size: 13px;\n}\n\n.iris-mascot--large .iris-mascot__bubble {\n    max-width: 340px;\n    padding: 12px 20px;\n}\n\n.iris-mascot--large .iris-mascot__bubble span {\n    font-size: 16px;\n}\n\n/* ===== Integration: Landing page ===== */\n.iris-greeting {\n    display: flex;\n    justify-content: center;\n    padding: 24px 24px 0;\n}\n\n/* ===== Integration: Dashboard ===== */\n.iris-dashboard {\n    display: flex;\n    justify-content: center;\n    margin: 16px 0 8px;\n}\n\n/* ===== Integration: Exercise finish ===== */\n.iris-finish {\n    display: flex;\n    justify-content: center;\n    animation: celebrationIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 768px) {\n    .iris-greeting {\n        padding: 16px 16px 0;\n    }\n\n    .iris-mascot__bubble {\n        max-width: 240px;\n    }\n}\n\n@media (max-width: 480px) {\n    .iris-mascot__bubble {\n        max-width: 200px;\n        padding: 8px 12px;\n    }\n\n    .iris-mascot__bubble span {\n        font-size: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
